module.exports = __webpack_public_path__ + "static/abstract-art1-4111417cfdd043f7d9d4daf3e20a1fa3.webp";